import React from 'react';
import { CheckIcon, ErrorIcon, SecurityIcon, CameraIcon, LightIcon, NetworkIcon } from './Icons';
import '../../styles/device-validation/ValidationResult.css';

const ValidationResult = ({ title, result, type }) => {
  if (!result) return null;

  const icons = {
    device: <SecurityIcon />,
    camera: <CameraIcon />,
    lighting: <LightIcon />,
    network: <NetworkIcon />
  };

  // Formata o valor para exibição segura
  const formatValue = (value) => {
    if (value === null || value === undefined) return 'N/A';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'number') return value.toFixed(2);
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };

  // Filtra e formata os detalhes para exibição
  const formatDetails = (details) => {
    if (!details || typeof details !== 'object') return {};
    
    const formatted = {};
    Object.entries(details).forEach(([key, value]) => {
      // Pula valores internos ou muito técnicos
      if (key === 'isDevelopment' || key === 'histogram' || key === 'stats') return;
      
      // Formata o nome da chave
      const formattedKey = key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .replace(/_/g, ' ');
      
      formatted[formattedKey] = formatValue(value);
    });
    
    return formatted;
  };

  const formattedDetails = formatDetails(result.details);
  const hasDetails = Object.keys(formattedDetails).length > 0;

  // Debug para verificar o status
  console.log(`ValidationResult [${title}]:`, {
    success: result.success,
    confidence: result.confidence,
    hasError: !!result.error
  });

  return (
    <div className={`validation-result ${result.success ? 'success' : 'error'}`}>
      <div className="validation-header">
        <div className="validation-title">
          {icons[type]}
          <span>{title}</span>
        </div>
        {/* Ícone baseado em result.success, não em detalhes */}
        {result.success ? <CheckIcon /> : <ErrorIcon />}
      </div>
      
      {hasDetails && (
        <div className="validation-details">
          {Object.entries(formattedDetails).map(([key, value]) => (
            <div key={key} className="detail-row">
              <span className="detail-key">{key}:</span>
              <span className="detail-value">{value}</span>
            </div>
          ))}
        </div>
      )}
      
      {result.confidence !== undefined && (
        <div className="confidence-indicator">
          <span className="confidence-label">Confiança:</span>
          <div className="confidence-bar">
            <div 
              className="confidence-fill" 
              style={{
                width: `${result.confidence}%`,
                backgroundColor: result.confidence > 70 ? '#00a859' : 
                               result.confidence > 40 ? '#ff9800' : '#e53935'
              }}
            />
          </div>
          <span className="confidence-value">{result.confidence}%</span>
        </div>
      )}
      
      {result.error && (
        <div className="alert alert-error validation-error">
          {result.error}
        </div>
      )}
    </div>
  );
};

export default ValidationResult; 